import { Checkbox } from '@carbon/react';
import { formatNumber } from 'utils/number';
import type { FilterTemplateProps } from '../../types';
import { useCategoryFields, useModalDuplicateCount } from '../template-hooks';
import style from '../filter-modal.module.scss';

export const CheckboxTemplate = ({
  category,
  formValues,
  onFormChange,
}: FilterTemplateProps) => {
  const fields = useCategoryFields(category, 'checkbox');
  // A boolean checkbox has no facet buckets, so a count (when the field opts in
  // via countFrom) is sourced here rather than from the facet aggregations.
  const duplicateCount = useModalDuplicateCount();

  /**
   * The checkbox label, with an optional match count appended (`countFrom`).
   * @param {(typeof fields)[number]} field The checkbox field.
   * @return {string} The label text.
   */
  const labelFor = (field: (typeof fields)[number]) =>
    // Only append a count the banner would also show — it hides below 1, so a 0
    // reads as "no count" here too rather than "(0)".
    field.countFrom === 'duplicateTotal' &&
    duplicateCount !== null &&
    duplicateCount > 0
      ? `${field.label} (${formatNumber(duplicateCount, 0)})`
      : field.label;

  return (
    <div className={style.fieldStack}>
      {fields.map((field) => (
        <Checkbox
          key={field.id}
          id={`filter-${field.id}`}
          labelText={labelFor(field)}
          checked={formValues[field.param] === 'true'}
          onChange={() =>
            onFormChange(
              field.param,
              formValues[field.param] === 'true' ? undefined : 'true'
            )
          }
        />
      ))}
    </div>
  );
};
